<template>
  <zb-select
    ref='zbSelect'
    :action="plansAction"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="slot in Object.keys({...$scopedSlots, ...$slots})" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zb-select>
</template>
<script>
import ZbSelect from '@/components/zoom-ui-plus/select/select.vue';

export default {
  name: 'CycleSelect',
  props: {
    plans: Array,
    action: Function,
  },
  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item.billing_cycle === oldVal);
      const newPlan = this.plans.find(item => item.billing_cycle === val);
      return this.action(oldPlan, newPlan);
    },
    focus() {
      this.$refs.zbSelect.focus();
    }
  },
  components: {
    ZbSelect,
  },
}
</script>
